/** @jsxImportSource @emotion/react */
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { steps } from 'modules/main/domain/const/steps';
import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { fetchMainPageInfo, selectStatus } from 'modules/main/store/main-page';
import Stepper from 'modules/main/ui/components/stepper/stepper';
import SectionPlayers from 'modules/main/ui/pages/main-page/sections/section-players/section-players';
import SectionTeams from 'modules/main/ui/pages/main-page/sections/section-teams/section-teams';
import SectionTournaments from 'modules/main/ui/pages/main-page/sections/section-tournaments/section-tournaments';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from 'store/store';
import type { DivProps } from 'typings';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'ud-ui/layout/main/context';
import * as S from './styles';

interface IProps extends DivProps {}

function MainPage(props: IProps) {
  const { ...rest } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { setHeaderContent } = useMainLayout();
  const userTournamentId = useSelector(authStoreUserTournamentId);
  const status = useSelector(selectStatus);

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Главная</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  useEffect(() => {
    if (userTournamentId && ((!status.loading && !status.loaded) || status.tournamentId !== userTournamentId)) {
      dispatch(fetchMainPageInfo({ tournamentId: userTournamentId }));
    }
  }, [dispatch, status.loaded, status.loading, status.tournamentId, userTournamentId]);

  const [isOpenStepper, setOpenStepper] = useState(!StepperMainTool.getByPath('stepper:main:close'));
  const isLoading = status.loading || !status.loaded;

  const closeStepper = useCallback(() => {
    setOpenStepper(false);
    StepperMainTool.setByPath('stepper:main:close', true);
  }, []);

  return (
    <S.MainBlock {...rest}>
      <Stepper
        header="Привет! 👋"
        subtitle="Давай запустим первый турнир по схеме ниже"
        steps={steps}
        onClose={closeStepper}
        isOpened={isOpenStepper}
      />

      <S.SectionsWrapper>
        <SectionTeams style={{ minWidth: 360 }} loading={isLoading} />
        <SectionPlayers style={{ minWidth: 399 }} loading={isLoading} />
        <SectionTournaments style={{ minWidth: 325 }} loading={isLoading} />
      </S.SectionsWrapper>
    </S.MainBlock>
  );
}

export default MainPage;
